import { ApiError, isApiError } from '../instance/error';
import { shouldThrowOnError } from './should-throw-on-error';

export function isHandledApiError(error: unknown): error is ApiError {
  if (!isApiError(error)) {
    return false;
  }

  return !shouldThrowOnError(error);
}
